/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantHoldingDetailsService {

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingDetailsV2(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-details-v2',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
